import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoprayagrajbusrental() {



  const cardData =
  {
    keyword: 'Pune to Prayagraj Bus Rental Service',
    heading: 'Sanavi Travels: Pune to Prayagraj Bus Rental Service',
    headingDescription: 'Sanavi Travels offers Pune to Prayagraj Bus Rental Service, providing safe, comfortable, and well-organized transportation for families, groups, pilgrims, corporate travel, and long-distance tours. Our fleet of well-maintained AC and Non-AC buses, mini buses, and luxury coaches ensures spacious seating, smooth long-distance journeys, and ample luggage space for a hassle-free experience. With experienced drivers, flexible one-way and round-trip bus rental options, transparent pricing, and 24/7 booking support, we ensure punctual and reliable travel from Pune to Prayagraj. Choose Sanavi Travels for trusted Pune to Prayagraj bus rental services, delivering comfort, safety, and convenience for a smooth and memorable journey.',

    top: 'Top Places to Visit in Prayagraj with Sanavi Travels',


"topPlaces": [
  {
    "title": "Prayagraj City",
    "description": "Prayagraj, formerly known as Allahabad, is one of India’s most ancient and sacred cities, deeply rooted in Hindu mythology, spirituality, and history. Located in Uttar Pradesh, the city stands at the confluence of the Ganga, Yamuna, and the mythical Saraswati rivers. Prayagraj has been a major center of learning, religion, and governance since Vedic times, making it a powerful blend of spiritual devotion, cultural heritage, and historical significance."
  },
  {
    "title": "Triveni Sangam",
    "description": "The Triveni Sangam is the most sacred site in Prayagraj, marking the confluence of the Ganga, Yamuna, and Saraswati rivers. Pilgrims believe that a holy dip here washes away sins and grants liberation. The Sangam is the focal point of the world-famous Kumbh Mela, attracting millions of devotees, saints, and tourists. The visible contrast of the rivers’ waters creates a mesmerizing and divine sight."
  },
  {
    "title": "Kumbh Mela Grounds",
    "description": "Prayagraj is globally renowned for hosting the Kumbh Mela, the largest religious gathering on earth. Held every 12 years, with Ardh Kumbh and Magh Mela in between, the event transforms the city into a vast spiritual hub. Sadhus, akharas, rituals, discourses, and sacred bathing ceremonies create an unmatched spiritual atmosphere."
  },
  {
    "title": "Anand Bhavan",
    "description": "Anand Bhavan is the ancestral home of the Nehru family and a major landmark of India’s freedom struggle. Now a museum, it showcases personal belongings, photographs, and historical documents related to Jawaharlal Nehru and the Indian National Congress. The site reflects India’s political and national heritage."
  },
  {
    "title": "Allahabad Fort",
    "description": "The Allahabad Fort, built by Mughal Emperor Akbar, stands majestically near the Sangam. The fort includes ancient temples, palaces, and the sacred Akshayavat tree. Although parts are under military control, the fort remains an important historical and architectural symbol of Prayagraj."
  },
  {
    "title": "Akshayavat",
    "description": "Akshayavat is a sacred fig tree located within the Allahabad Fort complex. According to Hindu belief, it is immortal and grants eternal blessings. Pilgrims consider darshan of Akshayavat highly auspicious, especially during Kumbh and Magh Melas."
  },
  {
    "title": "Hanuman Mandir (Lete Hanuman Ji)",
    "description": "This unique temple near the Sangam is famous for its reclining idol of Lord Hanuman. Devotees believe the temple protects Prayagraj from natural calamities. The idol is partially submerged during floods, which is considered sacred."
  },
  {
    "title": "Saraswati Ghat and Yamuna Ghat",
    "description": "The ghats along the rivers are centers for rituals, prayers, and daily spiritual activities. Devotees perform aarti, meditation, and ancestral rituals at these ghats, experiencing peace and devotion along the riverbanks."
  },
  {
    "title": "Cultural and Literary Heritage",
    "description": "Prayagraj has been home to great scholars, poets, and writers, earning it the title of a cultural and literary hub. The city has hosted prestigious literary gatherings and continues to be a center of intellectual and artistic pursuits."
  },
  {
    "title": "Spiritual and Historical Importance",
    "description": "Prayagraj is regarded as the ‘King of Tirthas’ in Hindu tradition. Its unmatched spiritual energy, combined with historical landmarks and cultural depth, makes it a once-in-a-lifetime destination for pilgrims, historians, and spiritual seekers."
  }
]
,



"services": [
{
"name": "Pune to Prayagraj Bus Rental Service",
"description": "Pune to Prayagraj Bus Rental Service offers reliable and well-organized bus transportation for devotees and travelers visiting Prayagraj. Ideal for pilgrimage groups, families, and tour organizers, this service provides comfortable seating, clean and well-maintained buses, and smooth long-distance travel. With experienced drivers and planned routes, passengers can enjoy a safe, peaceful, and well-coordinated journey from Pune to Prayagraj."
},
{
"name": "Prayagraj Bus Hire from Pune",
"description": "Prayagraj Bus Hire from Pune provides convenient and dependable bus hiring solutions for religious tours and sightseeing trips. Designed for group travel, this service focuses on timely departures, professional chauffeurs, and comfortable buses, making long-distance journeys stress-free and organized."
},
{
"name": "AC Bus Pune to Prayagraj",
"description": "AC Bus Pune to Prayagraj ensures a comfortable and refreshing travel experience with fully air-conditioned buses. Suitable for long-distance journeys, senior citizens, and family travel, these buses offer relaxed seating, smooth suspension, and climate-controlled comfort throughout the pilgrimage."
},
{
"name": "Luxury Bus Prayagraj Tour",
"description": "Luxury Bus Prayagraj Tour delivers a premium travel experience with modern interiors, pushback seats, and enhanced onboard amenities. Ideal for VIP groups, corporate pilgrims, and special religious tours, this service combines comfort, safety, and style for a memorable journey."
},
{
"name": "Religious Tour Bus Prayagraj",
"description": "Religious Tour Bus Prayagraj is designed specifically for devotees visiting sacred sites and participating in religious events. With disciplined drivers, organized travel schedules, and comfortable buses, this service ensures a peaceful and spiritually focused travel experience."
},
{
"name": "Family Prayagraj Trip",
"description": "Family Prayagraj Trip bus services are tailored for families seeking safe, comfortable, and organized travel. Spacious seating, smooth driving, and reliable scheduling ensure a pleasant journey for all age groups, making family pilgrimages convenient and stress-free."
},
{
"name": "Group Travel Prayagraj Bus",
"description": "Group Travel Prayagraj Bus provides efficient transportation for large groups, religious organizations, and tour operators. High-capacity buses, experienced chauffeurs, and coordinated travel planning ensure safe, comfortable, and well-managed group journeys."
},
{
"name": "Affordable Prayagraj Bus Rental",
"description": "Affordable Prayagraj Bus Rental offers cost-effective bus rental options without compromising on safety or comfort. Ideal for devotees, families, and groups, this service provides transparent pricing, dependable buses, and professional drivers for economical long-distance travel."
},
{
"name": "Chauffeur Driven Bus Prayagraj",
"description": "Chauffeur Driven Bus Prayagraj ensures a hassle-free travel experience with skilled drivers handling highways, traffic, and long-distance routes. This service emphasizes passenger safety, punctuality, and smooth driving for a relaxed pilgrimage journey."
},
{
"name": "Best Bus Service Pune to Prayagraj",
"description": "Best Bus Service Pune to Prayagraj is known for quality buses, reliable service, and customer satisfaction. Suitable for family pilgrimages, group tours, and religious travel, it prioritizes comfort, safety standards, and timely arrivals."
},
{
"name": "Pune Prayagraj Travel Bus",
"description": "Pune Prayagraj Travel Bus offers organized and dependable bus travel for devotees and tourists heading to Prayagraj. With comfortable seating, experienced drivers, and well-planned routes, this service ensures a smooth and enjoyable long-distance journey."
},
{
"name": "Tourist Bus Prayagraj",
"description": "Tourist Bus Prayagraj caters to travelers exploring Prayagraj and nearby spiritual and historical attractions. Flexible itineraries, comfortable buses, and professional drivers make sightseeing convenient and enjoyable for tourists and travel groups."
},
{
"name": "Outstation Bus Pune",
"description": "Outstation Bus Pune provides reliable long-distance bus services for interstate travel, including major pilgrimage destinations like Prayagraj. Well-maintained buses, trained drivers, and dependable scheduling ensure safe and comfortable extended journeys."
},
{
"name": "Online Bus Booking Prayagraj",
"description": "Online Bus Booking Prayagraj allows travelers to easily reserve buses with quick confirmation and flexible options. Multiple bus types, simple booking processes, and reliable service help plan Prayagraj trips efficiently and without hassle."
},
{
"name": "Pilgrimage Bus Tour",
"description": "Pilgrimage Bus Tour services provide organized and comfortable transportation for devotees traveling to sacred destinations like Prayagraj. With experienced chauffeurs, clean buses, and planned itineraries, this service ensures a spiritually enriching and well-managed pilgrimage experience."
}
],
"tableData": [
["Pune to Prayagraj Bus Rental Service", "Prayagraj Bus Hire from Pune"],
["AC Bus Pune to Prayagraj", "Luxury Bus Prayagraj Tour"],
["Religious Tour Bus Prayagraj", "Family Prayagraj Trip"],
["Group Travel Prayagraj Bus", "Affordable Prayagraj Bus Rental"],
["Chauffeur Driven Bus Prayagraj", "Best Bus Service Pune to Prayagraj"],
["Pune Prayagraj Travel Bus", "Tourist Bus Prayagraj"],
["Outstation Bus Pune", "Online Bus Booking Prayagraj"],
["Pilgrimage Bus Tour", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Pune to Prayagraj Bus Rental Service with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and comfortable bus rental services from Pune to Prayagraj, ideal for long-distance travel, group tours, family trips, and pilgrimage journeys."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Buses",
    "WhyChoosedescription": "Our buses are clean, air-conditioned, and regularly serviced to ensure a smooth and enjoyable journey from Pune to Prayagraj."
  },
  {
    "WhyChooseheading": "Experienced Long-Distance Drivers",
    "WhyChoosedescription": "Our licensed and professional drivers are experienced with long-distance routes, ensuring safe, timely, and stress-free travel for your group."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for Pune to Prayagraj bus rentals, including fuel, tolls, and driver allowances with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with bookings, itinerary planning, and travel queries throughout your journey."
  },
  {
    "WhyChooseheading": "Customizable Trip Plans",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized travel plans based on your schedule and travel needs for the Pune to Prayagraj route."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Coaches",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Pune to Prayagraj bus rentals."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus rental services from Pune to Prayagraj?',
    answer: 'Yes, Sanavi Travels offers dependable and comfortable bus rental services from Pune to Prayagraj for long-distance travel.'
  },
  {
    question: 'How can I book a Pune to Prayagraj bus rental?',
    answer: 'You can easily book a bus through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available for the Pune to Prayagraj route?',
    answer: 'Sanavi Travels offers a range of buses including mini buses, 20-seater, 32-seater, 45-seater, and 50-seater options to suit your group size.'
  },
  {
    question: 'Are the drivers experienced with long-distance travel?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with long-distance routes such as Pune to Prayagraj.'
  },
  {
    question: 'Can I customize my travel itinerary?',
    answer: 'Absolutely — you can customize pickup points, stops, and schedule according to your travel preferences.'
  },
  {
    question: 'Is the bus service available 24x7?',
    answer: 'Yes, Sanavi Travels offers round-the-clock assistance to help you plan and book your Pune to Prayagraj bus rental.'
  },
  {
    question: 'Are the buses sanitized before departure?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized to ensure a safe and hygienic travel experience.'
  },
  {
    question: 'What payment options are available?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments for your bookings.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Pune to Prayagraj bus trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohit Sharma',
    feedback: 'Booked a Pune to Prayagraj bus with Sanavi Travels — excellent service, comfortable coach, and smooth journey. Highly recommended!',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Anjali Verma',
    feedback: 'Our long-distance trip from Pune to Prayagraj was seamless and enjoyable thanks to Sanavi Travels — great support and experienced drivers!',
    rating: 5
  }
];

















































































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "BusTrip",
  "name": "Pune to Prayagraj Bus Rental Service - Sanavi Travels",
  "description": "Sanavi Travels offers Pune to Prayagraj bus rental services with AC and luxury buses. Perfect for religious tours, family trips, and group travel. Affordable, chauffeur-driven buses with online booking available.",
  "touristType": "Family Trip, Group Travel, Pilgrimage Tour, Religious Travel, Outstation Travel",
  "departureLocation": "Pune",
  "arrivalLocation": "Prayagraj, Uttar Pradesh",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "28"
  }
};






  return (
    <div>

<Helmet>
  <title>
    Pune to Prayagraj Bus Rental Service | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Pune to Prayagraj bus rental services by Sanavi Travels. AC and luxury buses for family trips, religious tours, group travel. Affordable, chauffeur-driven, with online booking."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/199.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoprayagrajbusrental;